import {Component, CUSTOM_ELEMENTS_SCHEMA, effect, inject, OnInit} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import {
  IonButton,
  IonCol,
  IonIcon,
  IonInput,
  IonLabel,
  IonRow,
  IonSegment,
  IonSegmentButton
} from "@ionic/angular/standalone";
import {LanguageService} from '../../core/language.service';
import {components} from '../../configs/config';
import {SelectCountryComponent} from '../../pages/contact/contact-form/select-country/select-country.component';
import {AuthService} from '../auth.service';
import {passwordStrengthValidator} from '../password-strength.validator';
import {passwordMatchValidator} from '../password-mach-validator';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AlertService} from '../../core/alert.service';
import {Auth, createUserWithEmailAndPassword} from '@angular/fire/auth';
import {LogoComponent} from "../../common/header/logo/logo.component";

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['../../pages/contact/contact-form/contact-form.component.scss','./register.component.scss'],
  imports: [
    FormsModule,
    IonInput,
    IonLabel,
    IonButton,
    ReactiveFormsModule,
    SelectCountryComponent,
    IonIcon,
    LogoComponent,
    RouterLink,
    IonRow,
    IonCol,
    IonSegment,
    IonSegmentButton
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RegisterComponent  implements OnInit {

  formTextContent: any;
  languageService: LanguageService = inject(LanguageService);
  register = new FormGroup({
    first_name: new FormControl('', [Validators.required]),
    last_name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone_number: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, passwordStrengthValidator()]),
    confirm_password: new FormControl('', [Validators.required]),
    role: new FormControl('client', [Validators.required]),
    accountType: new FormControl('tenant', [Validators.required]),
    uid: new FormControl('', ),
  }, { validators: [passwordMatchValidator('password', 'confirm_password')] } );
  prefix: string = '+966';
  authService: AuthService = inject(AuthService);
  route: ActivatedRoute = inject(ActivatedRoute);
  isSuccess: boolean = false;
  constructor() {
    effect(async () => {
      if (this.languageService.lang()) {
        this.formTextContent = await this.languageService.loadContent(components.forms);
      }
    });
  }

  isReadOnlyEmail = false;
  isGoogleLogin = false;
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['email']) {
        let name = '';
        if (params['displayName']) {
          name = params['displayName'].split(' ');
        }
        this.isReadOnlyEmail = true;
        this.register.patchValue({
          email: params['email'],
          uid: params['uid'],
          first_name: name[0],
          last_name: name[1],
        });
        this.isGoogleLogin = true;
        this.register.controls.password.removeValidators([Validators.required, passwordStrengthValidator()]);
        this.register.controls.confirm_password.removeValidators([Validators.required]);
        this.register.updateValueAndValidity();
      }
    })
  }
  countrySelected($event: any) {
    this.prefix = $event;
  }
  validateNumber(event: any): void {
    const inputValue = event.target.value;
    this.register.controls.phone_number.setValue(inputValue.replace(/[^0-9]/g, ''));
  }
  router: Router = inject(Router);
  alertService: AlertService = inject(AlertService);
  auth = inject(Auth);
  async registerUser() {
    const data: any = this.register.value;
    data.prefix = this.prefix;
    data.complete_phone_number = `${this.prefix}${data.phone_number}`;
    if (this.register.invalid) {
      // this.alertService.showToast('danger', 'Fill all fields');
      this.register.markAllAsTouched();
      return;
    }
    try {
      let user: any;
      if (!this.isGoogleLogin) {
        user = await createUserWithEmailAndPassword(this.auth, data.email, data.password);
        data.uid = user.user.uid;
      }

      try {
        const result: any = await this.authService.register(data);
        if (result.result !== 1) {
          this.isSuccess = true;
          setTimeout(() => {
            this.router.navigate(['/']);
          }, 2500);
        } else {
          await this.alertService.showToast('danger', result.message);
        }

      } catch (e: any) {
        await this.alertService.showToast('danger', e.message);
      }
    } catch (error: any) {
      console.log(error.message);
      await this.alertService.showToast('danger', error.message);
    }
  }

}
